/**
 * @file useContactFacade.hook.ts
 * @path apps/website/src/features/contact/hooks/useContactFacade.hook.ts
 */
import { useContactForm } from "./useContactForm.hook";
import { useFaqState } from "./useFaqState.hook";

export const useContactFacade = () => {
  const { form, submitForm, isSubmitting } = useContactForm();
  const { activeIndex, handleToggle, faqData } = useFaqState();

  return {
    contactForm: {
      form,
      isSubmitting,
      actions: {
        submit: form.handleSubmit(submitForm),
      },
    },
    faq: {
      items: faqData,
      activeIndex,
      actions: {
        toggle: handleToggle,
      },
    },
  };
};
